<section
	class="progress"
	aria-label="Add vet progress indicator"
	data-quat="value_workflowStepper"
>
	<ng-content select="mv-step"></ng-content>
</section>
